import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"

export const apiSlice = createApi({
    baseQuery: fetchBaseQuery({ baseUrl: "/api/v1/" }),
    tagTypes: ["Request"],
    endpoints: (builder) => ({
        userLogin: builder.query({
            query: (credentials) => ({
                url: `user/login`,
                method: "POST",
                body: credentials,
                headers: { "Content-Type": 'application/json' }
            })
        }),
        fetchRequests: builder.query({
            query: ({status, page, limit, token}) => ({
                url: `credit/all?status=${status}&page=${page}&limit=${limit}`,
                headers: { 'Authorization': `Bearer ${token}` }
            }),
            providesTags: ["Request"],
        }),
        fetchRequest: builder.query({
            query: ({id, token}) => ({
                url: `credit/${id}`,
                headers: { 'Authorization': `Bearer ${token}` }
            })
        }),
        fetchReports: builder.query({
            query: ({page, limit, token}) => ({
                url: `report/all?page=${page}&limit=${limit}`,
                headers: { 'Authorization': `Bearer ${token}` }
            })
        }),
        fetchReport: builder.query({
            query: ({id, token}) => ({
                url: `report/${id}`,
                headers: { 'Authorization': `Bearer ${token}` }
            })
        }),
        fetchLog: builder.query({
            query: ({id, token}) => ({
                url: `log/${id}`,
                headers: { 'Authorization': `Bearer ${token}` }
            })
        }),
        deleteLog: builder.mutation({
            query: ({id, token}) => ({
                url: `credit/delete?credit_id=${id}`,
                headers: { 'Authorization': `Bearer ${token}` }
            }),
            invalidatesTags: ["Request"]
        }),
        handleRequest: builder.mutation({
            query: ({patch, token}) => ({
                url: `credit/patch`,
                method: `PATCH`,
                body: patch,
                headers: { 'Authorization': `Bearer ${token}` }
            }),
            invalidatesTags: ["Request"]
        })
    })
})

export const { useUserLoginQuery, useFetchRequestsQuery, useFetchRequestQuery, useFetchReportsQuery, useFetchReportQuery, useFetchLogQuery, useDeleteLogMutation, useHandleRequestMutation } = apiSlice